import aviation from '../../assets/aviation.svg?raw';
import carbonRemoval from '../../assets/carbon-removal.svg?raw';
import circularity from '../../assets/circularity.svg?raw';
import energy from '../../assets/electricity.svg?raw';
import mobility from '../../assets/mobility.svg?raw';
import type { Category } from './types';

const sources: Record<Category, string> = {
	energy,
	circularity,
	carbon_removal: carbonRemoval,
	aviation,
	mobility,
};

export function createIcon(category: Category): SVGSVGElement {
	const template = document.createElement('template');
	template.innerHTML = sources[category].trim();
	const svg = template.content.querySelector('svg');
	if (!(svg instanceof SVGSVGElement)) {
		throw new Error('Ongeldig icoon.');
	}

	svg.removeAttribute('id');
	svg.querySelector('defs')?.remove();
	svg.querySelectorAll('path').forEach((path) => {
		path.removeAttribute('class');
		path.setAttribute('fill', 'currentColor');
		path.setAttribute('fill-rule', 'evenodd');
	});
	svg.setAttribute('aria-hidden', 'true');
	svg.classList.add('tulips-kaart__hotspot__callout__badge__icon');
	return svg;
}
